import { AttachFile, Create } from '@mui/icons-material'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { useState } from 'react'
import CarrosselModal from '../../../Components/CarrosselModal/CarrosselModal'
import { showNotify } from '../../../Utils/Utils'

const OcorrenciaDados = ({ ocorrencia, abrirModalOcorrencia }) => {
    const [openCarrossel, setOpenCarrossel] = useState(false)
    return (
        <Grid container sx={{
            height: {
                lg: '100px',
                xl: '60px'
            },
            width: '100%',
            backgroundColor: '#d9d9d900',
            borderRadius: '5px',
            padding: '5px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            border: '1px solid black'
        }}>
            {openCarrossel &&
            <CarrosselModal
                openCarrossel={openCarrossel}
                setOpenCarrossel={setOpenCarrossel}
                images={ocorrencia.anexos}
            />
            }
            <Grid container item
                sx={{
                    height: '100%',
                    width: '95%',
                    backgroundColor: '#d9d9d900',
                    borderRadius: '5px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start'
                }}
                gap={0.5}
            >
                <Grid container item sx={{
                    width: '100%',
                    height: '50%',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    borderBottom: '1px solid black'
                }}>
                    <Grid xl={2} lg={3}>
                        <Typography sx={typographySx} title={ocorrencia.data}>{ocorrencia.data}</Typography>
                    </Grid>
                    <Grid xl={3.5} lg={9}>
                        <Typography sx={typographySx} title={ocorrencia.autor}><span style={{ fontWeight: 'bold' }}>Criado por: </span>{ocorrencia.autor}</Typography>
                    </Grid>
                    <Grid xl={2.8} lg={5}>
                        <Typography sx={typographySx} title={`${ocorrencia.unidade1} - ${ocorrencia.unidade2}`}>
                            <span style={{ fontWeight: 'bold' }}>Imóvel: </span>{ocorrencia.unidade1} - {ocorrencia.unidade2}
                        </Typography>
                    </Grid>
                    <Grid xl={2.3} lg={3.5}>
                        <Typography sx={typographySx} title={ocorrencia.visivel_todos}>
                            <span style={{ fontWeight: 'bold' }}>Visivel P/ todos: </span>{ocorrencia.visivel_todos ? 'Sim' : 'Não'}
                        </Typography>
                    </Grid>
                    <Grid xl lg>
                        <Typography sx={typographySx} title={getStatus(ocorrencia.status)}>
                            <span style={{ fontWeight: 'bold' }}>Status: </span>{getStatus(ocorrencia.status)}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: {
                        lg: 2,
                        xl: 1
                    },
                    WebkitBoxOrient: 'vertical'
                }}>
                    <Typography sx={{
                        fontFamily: 'Montserrat',
                        fontSize: '15px',
                        fontWeight: 'bold'
                    }} title={ocorrencia.mensagem}>{ocorrencia.mensagem}</Typography>
                </Grid>
            </Grid>
            <Grid container item sx={{
                height: '100%',
                width: '5%',
                backgroundColor: '#d9d9d900',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center'
            }}>
                <AttachFile
                    onClick={() => {
                        ocorrencia.anexos.length > 0
                            ? setOpenCarrossel(true)
                            : showNotify('warning', 'Nenhum anexo encontrado para essa ocorrência!')
                    }}
                    sx={{
                        cursor: ocorrencia.anexos.length > 0 ? 'pointer' : 'default',
                        color: ocorrencia.anexos.length > 0 ? '#000000' : '#5f5f5f',
                        fontSize: '20px',
                        rotate: '45deg',
                        visibility: ocorrencia.anexos.length > 0 ? 'visible' : 'hidden'
                    }}/>
                <Create
                    onClick={() => abrirModalOcorrencia(ocorrencia)}
                    sx={{
                        cursor: 'pointer',
                        color: '#000000',
                        fontSize: '20px'
                    }}/>
            </Grid>
        </Grid>
    )
}

export default OcorrenciaDados
const getStatus = (status) => {
    switch (status) {
        case 0:
            return 'Aberto'
        case 1:
            return 'Em andamento'
        case 2:
            return 'Finalizado'
        default:
            return 'Erro'
    }
}

const typographySx = {
    fontFamily: 'Montserrat',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '12px',
    letterSpacing: '0em',
    textAlign: 'flex-start',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
}
